import React, { ReactNode, FC } from 'react'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'
import NavigationHeader from 'components/NavigationHeader/NavigationHeader'
import { getUrlPageValues } from '../utils'

interface VerticalPageWrapperProps {
  children?: ReactNode
  breadcrumbs?: ReactNode
  headerAction?: ReactNode
  gridContainerSx?: SxProps
  containerSx?: SxProps
}

const VerticalPageWrapper: FC<VerticalPageWrapperProps> = ({
  children,
  breadcrumbs,
  headerAction,
  gridContainerSx = {},
  containerSx = {},
}) => {
  const [, verticalType] = getUrlPageValues()

  return (
    <Box
      component='section'
      sx={{
        display: 'grid',
        gridTemplateRows: { md: 'minmax(50px, 5%) 1fr', xxxl: 'minmax(40px, 4%) 1fr' },
        height: '100%',
        pb: '20px',
        ...containerSx,
      }}
    >
      <Box
        sx={{
          alignSelf: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1,
          minHeight: 50,
        }}
      >
        <Box sx={{ minWidth: 0, overflow: 'hidden', flexShrink: 1 }}>
          {breadcrumbs || <NavigationHeader entityParam={verticalType} />}
        </Box>
        {headerAction && <Box sx={{ flexShrink: 0, ml: 2 }}>{headerAction}</Box>}
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: 'auto',
          gap: { md: '8px 22px', lg: '14px 22px', lgPlus: '12px 22px', xl: '14px 22px', xxl: '22px', xxxl: '22px' },
          ...gridContainerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default VerticalPageWrapper
